import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Table,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
  Tag,
} from "antd";
import {
  EditOutlined,
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
  AuditOutlined,
  UnorderedListOutlined,
  UserOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  RightOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
import dayjs from "dayjs";
const { Text } = Typography;

// STATUS
const options_status = [
  { value: 0, label: "Inativo" },
  { value: 1, label: "Ativo" },
];

export const CadPdi = () => {
  const navigate = useNavigate();
  const { id_colaborador } = useParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);
  const [search, setSearch] = useState("");

  const [colaborador, setColaborador] = useState({});

  useEffect(() => {
    if (id_colaborador) {
      listarPdis(id_colaborador);
      carregarColaborador(id_colaborador);
    }
  }, [id_colaborador]);

  // CARREGAR COLABORADOR
  const carregarColaborador = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_pdis_liberacoes/carregar_colaborador/${id}`, []);
    if (api.statusCode === 200) {
      if (!api?.response?.data) {
        navigate("/pdi/colaboradores");
      }
      setColaborador(api?.response?.data);
    } else {
      navigate("/pdi/colaboradores");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarPdis = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/pdi/listar/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      navigate("/pdi/colaboradores");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarPdi = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/pdi/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarPdis(id_colaborador);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarPdi = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/pdi/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      listarPdis(id_colaborador);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarPdi = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/pdi/carregar/${id}`, []);
    if (api.statusCode === 200) {
      if (api?.response?.data) {
        setShowModal(true);
        resetForm();
        form.setFieldsValue({
          descricao: api?.response?.data?.descricao,
          status: api?.response?.data?.status,
        });
        setIdAlt(api.response.data.id);
      }
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarPdi = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/pdi/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarPdis(id_colaborador);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // COLUNAS TABLE
  const columns = [
    {
      dataIndex: "descricao",
      title: "Descrição",
      sorter: (a, b) => a.descricao?.localeCompare(b.descricao),
    },
    {
      dataIndex: "status_competencias",
      title: "Situação",
      render: (_, e) =>
        e.status_competencias === 1 ? <Tag color="green">Concluído</Tag> : <Tag color="red">Pendente</Tag>,
      sorter: (a, b) => a.status_competencias?.toString()?.localeCompare(b.status_competencias?.toString()),
    },
    {
      key: "data_criacao",
      title: "Data",
      render: (_, e) => dayjs(e.data_criacao).format("DD/MM/YYYY"),
      sorter: (a, b) =>
        dayjs(a.data_criacao)
          .format("DD/MM/YYYY")
          ?.toString()
          ?.localeCompare(dayjs(b.data_criacao).format("DD/MM/YYYY")),
    },
    {
      key: "status",
      title: "Status",
      render: (_, e) => (e.status === 1 ? "Ativo" : "Inativo"),
      sorter: (a, b) => (a.status === 1 ? "Ativo" : "Inativo")?.localeCompare(b.status === 1 ? "Ativo" : "Inativo"),
    },
    {
      key: "acoes",
      title: "Ações",
      width: 150,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Competências">
            <Button
              loading={loading}
              onClick={() => navigate(`/pdi/colaboradores/pdis/${id_colaborador}/competencias/${e.id}`)}
              icon={<UnorderedListOutlined />}
            />
          </Tooltip>
          <Tooltip title="Editar">
            <Button loading={loading} onClick={() => carregarPdi(e.id)} icon={<EditOutlined />} />
          </Tooltip>
          <Tooltip title="Excluir">
            <Button
              loading={loading}
              icon={<DeleteOutlined />}
              onClick={() => {
                modal.confirm({
                  title: "Deseja deletar este registro?",
                  okText: "Sim",
                  cancelText: "Cancelar",
                  onOk() {
                    deletarPdi(e.id);
                  },
                });
              }}
            />
          </Tooltip>
          <Tooltip title="Liberação Colaboradores">
            <Button
              loading={loading}
              onClick={() => navigate(`/pdi/colaboradores/pdis/${id_colaborador}/colaboradores-liberacao/${e.id}`)}
              icon={<UsergroupAddOutlined />}
            />
          </Tooltip>
        </Space.Compact>
      ),
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    formulario.id_colaborador = id_colaborador;

    if (idAlt > 0) {
      formulario.id = idAlt;
      alterarPdi(formulario);
    } else {
      cadastrarPdi(formulario);
    }
  };

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter(
      (val) =>
        val.descricao?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        dayjs(val.data_criacao).format("DD/MM/YYYY")?.toLowerCase().includes(pesquisar.toLowerCase())
    );
    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  // FORMULÁRIO
  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} PDI
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="descricao"
                label="Descrição"
                rules={[{ required: true, message: "Digite a descrição!" }]}>
                <Input size="large" disabled={loading} placeholder="Informe a descrição" />
              </Form.Item>
            </Col>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="status" label="Status" rules={[{ required: true, message: "Selecione o status!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione o status"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_status}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="PDI" onClickBack={() => navigate("/pdi/colaboradores")} />
            <HeaderTitle
              title="PDIs Gestão"
              loading={loading}
              subtitle={
                <Text italic>
                  <UserOutlined /> {`${colaborador?.matricula ?? ""} - ${colaborador?.nome ?? ""}`}
                </Text>
              }
              icon={<AuditOutlined />}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                <Tooltip title="Adicionar Registro">
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setShowModal(true);
                      resetForm();
                    }}
                    loading={loading}>
                    Novo
                  </Button>
                </Tooltip>
              </Space>

              <Divider />

              <Table
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
                expandRowByClick
                rowKey="id"
                expandable={{
                  expandedRowRender: (data_children) => {
                    // COLUNAS TABLE
                    const columns_children = [
                      {
                        dataIndex: "descricao",
                        title: "Competência",
                      },
                      {
                        dataIndex: "total_finalizados",
                        title: <CheckCircleOutlined style={{ fontSize: 16, color: "#60b565" }} />,
                        width: 50,
                      },
                      {
                        dataIndex: "total_pendentes",
                        title: <ClockCircleOutlined style={{ fontSize: 16, color: "red" }} />,
                        width: 50,
                      },
                      {
                        key: "acoes",
                        title: "Ações",
                        width: 50,
                        render: (_, e) => (
                          <Tooltip title="Ações">
                            <Button
                              loading={loading}
                              onClick={() =>
                                navigate(
                                  `/pdi/colaboradores/pdis/${id_colaborador}/competencias/${data_children.id}/acoes/${e.id}`
                                )
                              }
                              icon={<RightOutlined />}
                            />
                          </Tooltip>
                        ),
                      },
                    ];

                    return (
                      <Table
                        loading={loading}
                        columns={columns_children}
                        dataSource={data_children.competencias}
                        pagination={false}
                        size="small"
                        rowKey="id"
                      />
                    );
                  },
                  defaultExpandedRowKeys: ["0"],
                }}
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
